import { render, staticRenderFns } from "./StakeholdersColumn.vue?vue&type=template&id=5e9db38b&scoped=true&"
import script from "./StakeholdersColumn.vue?vue&type=script&lang=js&"
export * from "./StakeholdersColumn.vue?vue&type=script&lang=js&"
import style0 from "./StakeholdersColumn.vue?vue&type=style&index=0&id=5e9db38b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9db38b",
  null
  
)

export default component.exports